import { SavedFilter } from 'types/PropertyFilters';
import { validateAndCleanFilter } from './filterValidation';

const LOCAL_STORAGE_KEYS = {
    TOKEN: 'token',
    FLAGS: 'flags',
    REFRESH_TOKEN: 'refreshToken',
    FILTER_LIST: 'filterList',
};

export const logoutUserAndClearLocalStorage = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.FLAGS);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);

    window.location.href = '/signin';
};

export const saveAccessAndRefreshTokenToLocalStorage = (accessToken: string, refreshToken: string) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, accessToken);
    localStorage.setItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
};

export const getTokenFromLocalStorage = () => localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);

export const getRefreshTokenFromLocalStorage = () => localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);

const migrateFilterType = (filter: SavedFilter): SavedFilter => {
    if (filter && filter.filter && typeof filter.filter.type === 'string') {
        const typeValue = filter.filter.type as unknown as string;
        filter.filter.type = typeValue ? [typeValue] : [];
    }

    // Ensure availability field exists
    if (filter && filter.filter && !filter.filter.availability) {
        filter.filter.availability = ['available'];
    }

    return filter;
};

export const saveFiltersToLocalStorage = (filters: SavedFilter[]) => localStorage.setItem('filterList', JSON.stringify(filters));

export const getFiltersFromLocalStorage = (): SavedFilter[] | null => {
    const filtersJson = localStorage.getItem('filterList');
    if (!filtersJson) return null;

    try {
        const filters = JSON.parse(filtersJson);
        return Array.isArray(filters) ? filters.map(migrateFilterType) : null;
    } catch (e) {
        console.error('Error parsing stored filters:', e);
        return null;
    }
};
